<template>
  <div class="user-management-view site-container" id="device-management-view">
    <div class="display-flex justify-end">
      <div class="display-flex mt-12 gap-6">
        <button class="button-tab" :class="{ active: currentComponent === 'cctv'}" @click="showComponent('cctv')">CCTV Management</button>
        <button class="button-tab" :class="{ active: currentComponent === 'edge'}" @click="showComponent('edge')">Edge Management</button>
        <button class="button-tab" :class="{ active: currentComponent === 'asset'}" @click="showComponent('asset')">Asset Management</button>
      </div>
    </div>
    <div v-if="currentComponent === 'cctv'">
      <CCTVManagement />
    </div>
    <div v-if="currentComponent === 'edge'">
      <EdgeManagement />
    </div>
    <div v-else-if="currentComponent === 'asset'">
      <AssetManagement />
    </div>
  </div>
  
</template>

<script>

import CCTVManagement from "./CCTVManagement.vue";
import EdgeManagement from "./EdgeManagement.vue";
import AssetManagement from "./AssetManagement.vue";
// import { mapGetters } from 'vuex';
export default {
  name: 'DeviceManagementView',
  components: {
    CCTVManagement,
    EdgeManagement,
    AssetManagement,
  },
  data() {
    return {
      currentComponent: 'asset',
      isShowGroupUser: true,
      componentKey: 0,
    } 
  },
  methods: {
    showComponent(component) {
      this.currentComponent = component;
    },
  },
  // computed: {
  //   ...mapGetters("common", {
  //     getterAccessibleMenus: "getterAccessibleMenus",
  //     getterRole: "getterRole"
  //   }),
  //   userGroupVisibility() {
  //     return this.getterRole === 2;
  //   }
  // },
};

</script>

<style scoped lang="scss">
@import "./deviceManager.scss";
</style>
 